import React from 'react';
import { UIComparisonDemo } from '../../components/projectmng/obtainorder/v2';

/**
 * UI 비교 데모 페이지
 * 수주품의서 기존 UI와 개선된 UI(V2)를 비교할 수 있는 페이지
 * 
 * 접속 경로: /ui-demo/order-book
 */
const OrderBookUIComparePage = () => {
  return <UIComparisonDemo />;
};

export default OrderBookUIComparePage;
